/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 * Export all filters
 */
import AduanasFilter from './aduanas';
import DespachosFilter from './despachos';
import ClientesFilter from './clientes';
import ConceptosFilter from './conceptos';
import ProveedoresFilter from './proveedores';
import UsuariosFilter from './usuarios';

export {
    AduanasFilter,
    DespachosFilter,
    ClientesFilter,
    ConceptosFilter,
    ProveedoresFilter,
    UsuariosFilter
};



// WEBPACK FOOTER //
// ./components/filters/index.js